// extracted by mini-css-extract-plugin
module.exports = {"OtpRequestForm":"OtpRequestForm_OtpRequestForm__qJ7os","Text":"OtpRequestForm_Text__seuHF","ErrorMessage":"OtpRequestForm_ErrorMessage__OnWxy"};